export default __webpack_public_path__ + "static/media/leftArrow.93a1319e.svg";